import { ModelSagres } from "../model-sagres"

export class ArquivoConvenio extends ModelSagres {
    IdArquivo: number
    IdConvenio: number
    DePathArquivo: string
    DeNomeArquivo: string
    IsArquivoEdital: boolean
    NmUsuarioResponsavel: string
    DtInsercao: Date
}